<script lang="ts">
	// optional props
	export let title = '';
</script>

<span
	class={`flex items-center ${
		title
			? 'lg:after:ml-4 text-white before:mr-2 before:block before:flex-1 before:border-b-2 before:border-zinc-700 after:ml-2 after:block after:flex-1 after:border-b-2 after:border-zinc-700 lg:before:mr-4'
			: 'border-b-2 border-zinc-700'
	} ${$$props.class ? $$props.class : ''}`}
>
	{#if title}
		<p class="handwritten text-sm">{title}</p>
	{/if}
</span>
